import { createContext, useContext } from "react";
import type { NamespaceSelection } from "./namespaceSelection";

/** AppShell이 검증된 partition 신원을 확보하기 전 선택 의존 요청을 동기적으로 막습니다. */
export const NamespaceSelectionIdentityContext = createContext(true);

export function useNamespaceSelectionIdentityReady(): boolean {
  return useContext(NamespaceSelectionIdentityContext);
}

/** 검증된 AppShell 선택 경계만 내부 리소스 이동에 노출합니다. */
export const NamespaceSelectionApplyContext = createContext<(_selection: NamespaceSelection) => boolean>(() => false);

export function useApplyNamespaceSelection(): (selection: NamespaceSelection) => boolean {
  return useContext(NamespaceSelectionApplyContext);
}
